/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Costs_InvalidInputs */

const id_tld_pricing_costs_invalid = /** @type {(inputs: Tld_Pricing_Costs_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi harga registrasi untuk setiap masa yang aktif.`)
};

const en_tld_pricing_costs_invalid = /** @type {(inputs: Tld_Pricing_Costs_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give every enabled term a register price.`)
};

/**
* | output |
* | --- |
* | "Give every enabled term a register price." |
*
* @param {Tld_Pricing_Costs_InvalidInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_costs_invalid = /** @type {((inputs?: Tld_Pricing_Costs_InvalidInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Costs_InvalidInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_costs_invalid(inputs)
	return id_tld_pricing_costs_invalid(inputs)
});